import { useCallback, useEffect, useMemo, useState } from 'react';
import { ButtonCancel, ButtonSave, LoadingTable, ModalBody, ModalDraggable, ModalFooter, ModalHeader } from '../../components/base';

import { useDispatch, useSelector } from 'react-redux';
import { DataTable, IDataTableColumn } from '../../components/common/DataTable';
import ComboBoxProductCategory from '../../components/shared/hoc-product-category/ComboBoxProductCategory';
import { no_img } from '../../components/shared/hoc-static';
import { eBaseActionStatus } from '../../context/base/eBaseActionStatus';
import { actions } from '../../context/stores/rootActions';
import { AppState } from '../../context/stores/rootReducers';

type IProductTypeProductModalProps = {
	isShow: boolean;
	isSaving: boolean;
	productTypeId: number;
	isDisabled?: boolean;
	onClose: () => void;
};

const ProductTypeProductModal = (props: IProductTypeProductModalProps) => {
	const { isShow, isSaving, onClose, productTypeId } = props;
	const dispatch = useDispatch();
	const [filterModal, setFilterModal] = useState({
		catId: 0,
	});

	const { allProductByCategory } = useSelector((state: AppState) => state.productTypeProduct);
	const { statusCat, selectedProductIds } = useSelector((state: AppState) => state.productTypeProduct);

	var handleChangeProductIds = useCallback((productIds: number[]) => {
		dispatch(actions.productTypeProduct.changeSelectedProductIds(productIds || []));
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// const onSubmitHandler = (values: ProductTypeProductResponse) => {
	// 	onSubmit(values);
	// };

	const handleReloadData = useCallback(() => {
		dispatch(
			actions.productTypeProduct.getByCategoryRequest({
				Cat_Id: filterModal.catId,
			})
		);
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterModal.catId]);

	const handleSaveData = useCallback(() => {
		if (selectedProductIds.length > 0) {
			dispatch(
				actions.productTypeProduct.productTypeSaveRequest({
					IDProducts: selectedProductIds,
					IDProductType: productTypeId,
				})
			);
			onClose();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [productTypeId, selectedProductIds]);

	useEffect(() => {
		handleReloadData();
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterModal.catId]);

	// useEffect(() => {
	// 	if (statusCat === eBaseActionStatus.reload){
	// 		onClose();
	// 	}
	// 	//eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [statusCat]);

	const columns = useMemo((): IDataTableColumn<any>[] => {
		return [
			{ accessorKey: 'name', header: 'Tên sản phẩm', size: 200, meta: { align: 'center' } },
			{
				accessorKey: 'image',
				header: 'Ảnh',
				size: 100,
				cell: ({ row }) => {
					const picture = row.original;
					return (
						<div className='flex items-center gap-2'>
							<div className='hidden md:flex flex-shrink-0 w-12 h-12 rounded-md border border-border/50 bg-background overflow-hidden items-center justify-center shadow-sm'>
								<img src={picture.image?.length > 0 ? picture.image : no_img} alt='ảnh' className='object-cover w-full h-full rounded-sm' />
							</div>
						</div>
					);
				}
			},
			{ accessorKey: 'sku', header: 'SKU', minSize: 150 },
			{ accessorKey: 'price', header: 'Giá', minSize: 150 },
			{ accessorKey: 'priceOnSale', header: 'Giá đã giảm', minSize: 150 }
		];
	}, []);

	return (
		<>
			<ModalDraggable show={isShow} sizeClass='xl' type='primary' onClose={onClose}>
				<ModalHeader classDragg={true} title={'Danh sách sản phẩm'} onClose={() => onClose()} />
				<ModalBody>
					{statusCat === eBaseActionStatus.loading && <LoadingTable />}
					{statusCat !== eBaseActionStatus.loading && (
						<DataTable
							data={allProductByCategory}
							columns={columns}
							isLoading={statusCat !== eBaseActionStatus.complete}
							enableRowSelection
							rowSelection={selectedProductIds.reduce((acc: any, id: number) => ({ ...acc, [String(id)]: true }), {})}
							onRowSelectionChange={(selection) => {
								handleChangeProductIds(Object.keys(selection).filter(k => selection[k]).map(Number));
							}}
							enablePagination={false}
							enableGlobalFilter={false}
							toolbar={{
								isShowSearch: false,
								extraActions: (
									<ComboBoxProductCategory
										name={'catId'}
										onValueChanged={(value) => {
											setFilterModal((prev) => ({ ...prev, catId: value }));
										}}
										value={filterModal.catId}
										hasValid={true}
									/>
								)
							}}
							onRefresh={handleReloadData}
						/>
					)}
				</ModalBody>
				<ModalFooter>
					<ButtonCancel onClick={onClose} isDisabled={isSaving} />
					<ButtonSave type='button' isLoading={isSaving} isDisabled={isSaving} onClick={() => handleSaveData()} text={'Thêm sản phẩm'} />
				</ModalFooter>
			</ModalDraggable>
		</>
	);
};

export default ProductTypeProductModal;
